import { useTranslation } from "gatsby-plugin-react-i18next";
import ContentCard from "../../components/ContentSlider/components/ContentCard/ContentCard";
import ProductCardSlider from "../../components/ProductCardSlider/ProductCardSlider";
import GridItem from "../../components/general/GridItem";
import ImageContainer from "../../components/general/ImageContainers/ImageContainer";
import Link from "../../components/general/Link";
import { getUrlFromStoryblokLink } from "../../utils/storyblok/urls";
import { getOriginalVimeoThumbnail } from "../../utils/vimeo/utils";

const ContentSlideModule = ({
	title,
	label,
	cards,
}: Queries.ContentSlideModuleFragment) => {
	const { t } = useTranslation();
	return (
		<GridItem fullWidth>
			<ProductCardSlider
				title={title}
				label={label}
				ariaLabelNext={t("next")}
				ariaLabelPrev={t("previous")}
			>
				{cards?.map((card) => (
					<ContentCard
						key={card?._uid}
						image={
							<Link
								anchor={card?.link?.anchor ?? undefined}
								href={
									!!getUrlFromStoryblokLink(card?.link) &&
									!card?.video?.filename &&
									!card?.youtubeEmbedId &&
									!card?.vimeo?.vimeo_oembed?.response
										? getUrlFromStoryblokLink(card?.link)
										: undefined
								}
							>
								<ImageContainer
									alt={card?.image?.alt ?? undefined}
									ratio="landscape"
									imgSrc={
										card?.image?.filename ||
										getOriginalVimeoThumbnail(
											card?.vimeo?.vimeo_oembed?.response?.thumbnail_url ?? "",
										) ||
										""
									}
									objectFit="cover"
									videoSrc={card?.video?.filename || ""}
									youtubeEmbedId={card?.youtubeEmbedId || ""}
									vimeoResponse={
										card?.vimeo?.vimeo_oembed?.response || undefined
									}
									withPlayButton={
										!!card?.video?.filename ||
										!!card?.youtubeEmbedId ||
										!!card?.vimeo?.vimeo_oembed?.response
									}
								/>
							</Link>
						}
						title={card?.title || ""}
						label={card?.label || ""}
					/>
				))}
			</ProductCardSlider>
		</GridItem>
	);
};

export default ContentSlideModule;
